export default (function (v) {
  return v;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/identity.js
// module id = 114
// module chunks = 0